module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_CN_Mobile.841c9cc0.webp";